module.exports = __webpack_public_path__ + "static/img/banner-go-download.38e7984.jpg";